/**
 * Progress Service
 * Handles all progress tracking related API calls
 *
 * @module services/ProgressService
 */

import BaseService from "../core/api/BaseService";

class ProgressService extends BaseService {
  constructor() {
    super("/progress");
  }

  async startSession(sessionData) {
    return this.post("start-session", sessionData);
  }

  async updateProgress(progressData) {
    return this.post("update", progressData);
  }

  async getUserStats() {
    return this.get("user");
  }

  async getStreakData(days = 30) {
    return this.get("streak", { days });
  }

  async getContentProgress(contentType, contentId) {
    return this.get(`content/${contentType}/${contentId}`);
  }

  async getCourseProgress(courseId) {
    return this.get(`content/course/${courseId}`);
  }
}

export default new ProgressService();
